<template>
  <div class="playerWrapper">
    <div :id="`video-${video.id}-player`" class="video-player-wrapper">
      <div class="video-player-container">
        <div class="video-player player">
          <video
            ref="videoPlayer"
            class="video-js"
            width="590"
            height="405"
            tabindex="0"
            :poster="video.poster"
            controls="controls"
            preload="none"
            :id="newUniqueId"
            :data-event-label="`video-${video.id}`"
          >
            <source v-for="source in video.sources" :src="source.src" :type="source.type" :label="source.label" ref="source">
            <template v-if="!hideTrack">
              <track v-for="track in video.tracks" :kind="track.kind" :src="track.src">
            </template>
          </video>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { random } from 'lodash'
import { initVideoPlayer, destroyVideoPlayer } from 'video/videoJsPlayer'

export default {
  name: "VideoPlayer",
  props: {
    videoProp: {
      type: Object
    },
    videoUniqueId: {
      type: Boolean,
      required: false
    },
    hideTrack: {
      type: Boolean,
      required: false
    }
  },
  mounted() {
    initVideoPlayer(this.$refs.videoPlayer)
  },
  computed: {
    video() {
      return this.videoProp
    },
    newUniqueId() {
      if (!this.videoUniqueId) return `video-${this.video.id}`
      return `video-${this.video.id}-${random(1000000)}`
    }
  },
  beforeUnmount() {
    destroyVideoPlayer(this.$refs.videoPlayer)
  }
}
</script>
